/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBREVENUENEW, GETPERIOD } from './constants'
import { endTime, startTime } from '../../util'

const initState = {
  period: { start_time: startTime(true), end_time: endTime(true) },
  statisticType: 1,
}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBREVENUENEW:
      return Object.assign({}, state, { revenueList: action.payload })
    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRevenueNew/reduce.js